<template>
  <div style="padding:10px;background-color: #F5F5F5;min-height: 100%">

    <Card  :bordered="false" :dis-hover="true" style="margin-bottom:10px;">
      <div style="text-align:left">
        <Row>
          <Col span="19">
            <Button type="primary" @click="modal1=true">增加</Button>
          </Col>
          <Col span="5">
             <Input search enter-button placeholder="输入关键词搜索" v-model="serch.key"  @on-search="load"/>
          </Col>
        </Row>
      </div>
    </Card>

    <Card :dis-hover="true">
      <Spin fix v-if="loading"></Spin>
      <el-table :data="list" size="small" style="width: 100%" >
        <el-table-column prop="id" label="编号" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="bk" label="所属板块" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="name" label="权限名称" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="note" label="备注" :show-tooltip-when-overflow="true"></el-table-column>

        <el-table-column prop="msg" label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <a @click="edit(scope.row.id)">编辑</a>
<!--            <cite>|</cite>-->
<!--            <a @click="remove(scope.row.id)">删除</a>-->
          </template>
        </el-table-column>
      </el-table>
    </Card>

    <Card  :bordered="false" dis-hover style="text-align: center;margin-top:10px">
      <Page :total="count" show-total :page="page" @on-page-size-change="limitChange"  show-elevator @on-change="change"  show-sizer :page-size-opts="[10, 30,50,100]"></Page>
    </Card>

    <Modal
      v-model="modal1"
      title="增加或编辑"
      @on-ok="save"
      @on-cancel="cancel">
      <Form :label-width="80">
				<FormItem label="所属板块">
          <Field :type="55" :addbtn="true"  v-model="detail.bk"></Field>
				</FormItem>
				<FormItem label="权限名称">
					<Input v-model="detail.name"/>
				</FormItem>
				<FormItem label="备注">
					<Input v-model="detail.note"/>
				</FormItem>
      </Form>
    </Modal>

  </div>
</template>

<script>
  import Field from "../common/field/Field";
  export default {
    components:{Field},
    data(){
      return{
        baseUrl:'/api/power/powerlist/',
        list:[],
        page:1,
        count:0,
        limit:10,
        modal1:false,
        detail:{},
        serch:{
          key:''
        },
        loading:false,
      }
    },
    methods:{
      load(){
        let that = this;
        let params = [];
        if(this.serch.key){
          params.push('t.id@=@'+this.serch.key);
        }
        that.loading = true;
        this.$axios.get(this.baseUrl+'findall?page='+this.page+'&limit='+this.limit+'&params='+params).then(function(rs){
          that.list = rs.data.data;
          that.count = rs.data.count;
          that.loading = false;
        });
      },
      limitChange(val){
        this.limit = val;
        this.load();
      },
      change(val){
        this.page = val;
        this.load();
      },
      save(){
        let that = this;
        let data = Object.assign({}, this.detail);
        this.$axios({url:this.baseUrl+'save',method:'post',data:this.$qs.stringify(data)}).then(function(rs){
          that.toast(rs.data);
          if(rs.data.success){
            that.detail = {};
          }
        });
      },
      edit(id){
        let that = this;
        this.$axios.get(this.baseUrl+'getById?id='+id).then(function(rs){
          that.detail = rs.data;
          that.modal1 = true;
        });
      },
      remove(id){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要删除吗',
          onOk: () => {
            let that = this;
            this.$axios.get(this.baseUrl+'delete?ids='+id).then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      toast(data){
        if(data.success){
          this.load();
          this.$Message.success(data.msg);
        }else{
          this.$Message.error(data.msg);
        }
      }
    },
    created(){
      this.load();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/power/PowerList.vue